import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-604a6033"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-5" }
const _hoisted_2 = { class: "timeline-label" }
const _hoisted_3 = {
  style: {"width":"100px"},
  class: "timeline-label fw-bolder text-gray-800 fs-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-success fs-1" })
], -1))
const _hoisted_5 = { class: "timeline-content d-flex" }
const _hoisted_6 = { class: "fw-bolder text-gray-800 ps-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investmentsTemp, (investment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: investment.id,
            class: "timeline-item"
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate(investment?.createdAt)), 1),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(`${_ctx.currencyCodeTemp} ${investment?.investment} Invested By ${investment?.investor?.user?.firstName ?? ''} ${investment?.investor?.user?.lastName ?? ''}`), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}